module.exports = __webpack_public_path__ + "img/pr-1.65832638.png";